define([
	"dojo/_base/declare",
	"Apparel/StructureItemTable",
	"SiteAdmin/DataSheetTablePreferences",
	"Specification/BOM/BOMCustomViewOptionsStore",
	"Specification/BOM/BOMOptionsTab",
	"Specification/PartMaterialMixin"
], function(declare, StructureItemTable, DataSheetTablePreferences, BOMCustomViewOptionsStore, BOMOptionsTab, PartMaterialMixin) {

	var _Preferences = declare(DataSheetTablePreferences, {
		constructor: function() {
			this.addCustomOption("displayColorImages", true, false, "DisplayColorImages");
			this.addCustomOption("displaySupplierCodes", false, false, "DisplaySupplierCodes");
			this.removeCustomOption("displayCommentLines");
		}
	});

	return declare([StructureItemTable, PartMaterialMixin], {
		allowSuspendInCustomViewPreview: true,
		customViewOptionsComponent: BOMOptionsTab,
		customViewOptionsStore: BOMCustomViewOptionsStore,
		prefClass: _Preferences,

		// Boolean: if true then display color image with color references
		//displayColorImages: false,

		// Boolean: if true then display supplier codes for color and size references
		//displaySupplierCodes: false,

		_resolveView: function() {
			// summary: resolve view path and/or filters
			this._resolveViewPath(this);
			this._resolveViewFilter(this);
			this.inherited(arguments);
		}
	});
});
